import * as React from "react";
import classNames from "classnames";

import { useBuyerCategoriesById } from "../hooks/api/buyer/useBuyerCategories";

import css from "./BuyerCategoryLabel.module.scss";

export type Props = {
  buyerCategoryId: string;
  size?: "small" | "default"; // small - font-size 12px, normal: default font size
  className?: string;
};

function BuyerCategoryLabel({ buyerCategoryId, size, className }: Props): JSX.Element | null {
  const { data: buyerCategories } = useBuyerCategoriesById();

  const category = buyerCategories.get(buyerCategoryId);
  if (!category) {
    return null;
  }

  const parent = category.parentCategoryId
    ? buyerCategories.get(category.parentCategoryId)
    : undefined;

  return (
    <div
      className={classNames(
        css.pairContainer,
        size === "small" ? css.labelSizeSmall : null,
        className,
      )}
    >
      {parent && (
        <>
          <span>{parent.name}</span>
          <span className={css.divider}>&gt;</span>
        </>
      )}
      <span>{category.name}</span>
    </div>
  );
}

export default BuyerCategoryLabel;
